// The form templates as the screens read them. A self-service template keeps the audience chosen on it,
// as the wizard offers it to that audience only (AD-2581); every other template is offered by its
// type and category, so its stored audiences are not passed on (AD-2537).
const SELF_SERVICE = 'selfService';
const audiencesFor = (template) => (template.type === SELF_SERVICE ? template.audiences ?? [] : undefined);

export const formTemplateFromApi = (template) => ({
    id: template.id,
    name: template.name,
    schema: JSON.parse(template.schema),
    type: template.type,
    category: template.category,
    parentCategory: template.parentCategory,
    schoolId: template.schoolId,
    audiences: audiencesFor(template),
    // AD-2581: a form built from this template goes to children on roll only.
    onRollOnly: Boolean(template.onRollOnly)
});

export const sharedTemplateFromApi = (template) => ({
    id: template.id,
    name: template.name,
    type: template.type,
    categoryId: template.categoryId,
    category: template.category,
    parentCategory: template.parentCategory,
    audiences: audiencesFor(template),
    schema: template.schema,
    createdAt: template.createdAt,
    createdBy: template.createdBy,
    isHidden: template.isHidden,
    hiddenAt: template.hiddenAt,
    hiddenBy: template.hiddenBy
});
